import {
  Paginated,
  FundAnalysis,
  SchemeAnalysis,
  SubmissionSummary,
  SubfundAnalysis,
  PaginatedV2,
  OrganisationAnalysis,
  FiduciaryAnalysis
} from '../types';

export interface IAnalysisState {
  fetchingFundAnalysis: boolean;
  fundAnalysis?: Paginated<FundAnalysis>;
  schemeAnalysis?: PaginatedV2<SchemeAnalysis>;
  submissionSummary?: SubmissionSummary;
  subfundAnalysis?: PaginatedV2<SubfundAnalysis>;
  consultantAnalysis?: OrganisationAnalysis;
  providerAnalysis?: OrganisationAnalysis;
  fiduciaryAnalysis?: PaginatedV2<FiduciaryAnalysis>;
}

export const AnalysisState: IAnalysisState = {
  fetchingFundAnalysis: false,
  fundAnalysis: undefined,
  schemeAnalysis: undefined,
  submissionSummary: undefined,
  subfundAnalysis: undefined,
  consultantAnalysis: undefined,
  providerAnalysis: undefined,
  fiduciaryAnalysis: undefined
};
